var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUpdateBenef(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7584_34964)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 3.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#5754E5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4785 11.9665L26.3309 11.1141C27.0371 10.4079 28.1819 10.4079 28.888 11.1141C29.5941 11.8202 29.5941 12.9651 28.888 13.6712L28.0356 14.5236M25.4785 11.9665L19.7448 17.7001C19.3078 18.1372 18.9978 18.6846 18.8479 19.2841L18.2246 21.7775L20.718 21.1541C21.3175 21.0043 21.8649 20.6943 22.302 20.2573L28.0356 14.5236M25.4785 11.9665L28.0356 14.5236",
    stroke: "#5754E5",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6939 19.6249C27.6939 22.4555 27.6939 23.8707 26.9122 24.8233C26.7691 24.9977 26.6092 25.1575 26.4348 25.3006C25.4823 26.0824 24.067 26.0824 21.2364 26.0824H20.806C17.5589 26.0824 15.9354 26.0824 14.9267 25.0737C13.918 24.065 13.918 22.4414 13.918 19.1944V18.7639C13.918 15.9334 13.918 14.5181 14.6997 13.5656C14.8428 13.3912 15.0027 13.2313 15.1771 13.0881C16.1297 12.3064 17.545 12.3064 20.3755 12.3064",
    stroke: "#5754E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4785 11.9665L26.3309 11.1141C27.0371 10.4079 28.1819 10.4079 28.888 11.1141C29.5941 11.8202 29.5941 12.9651 28.888 13.6712L28.0356 14.5236M25.4785 11.9665L19.7448 17.7001C19.3078 18.1372 18.9978 18.6846 18.8479 19.2841L18.2246 21.7775L20.718 21.1541C21.3175 21.0043 21.8649 20.6943 22.302 20.2573L28.0356 14.5236M25.4785 11.9665L28.0356 14.5236",
    stroke: "#5754E5",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6939 19.6249C27.6939 22.4555 27.6939 23.8707 26.9122 24.8233C26.7691 24.9977 26.6092 25.1575 26.4348 25.3006C25.4823 26.0824 24.067 26.0824 21.2364 26.0824H20.806C17.5589 26.0824 15.9354 26.0824 14.9267 25.0737C13.918 24.065 13.918 22.4414 13.918 19.1944V18.7639C13.918 15.9334 13.918 14.5181 14.6997 13.5656C14.8428 13.3912 15.0027 13.2313 15.1771 13.0881C16.1297 12.3064 17.545 12.3064 20.3755 12.3064",
    stroke: "#5754E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7584_34964",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7584_34964"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.127814 0 0 0 0 0.115177 0 0 0 0 0.725962 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7584_34964"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7584_34964",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpdateBenef);
export default __webpack_public_path__ + "static/media/iconUpdateBenef.1fd581c1e7be862027d8d3c7606e01fd.svg";
export { ForwardRef as ReactComponent };